module.exports = __webpack_public_path__ + "media/sv-ed64e2bb.mp4";